// extracted by mini-css-extract-plugin
export default {"title":"H-CY0","skeleton-progress":"c8xZR"};